export const joinSafely = (separator: string, ...args: (string | undefined)[]): string | undefined => {
  let joined = ""

  for (const arg of args) {
    if (!arg) {
      return undefined
    }

    if (joined.length > 0) {
      joined += separator
    }

    joined += arg
  }

  return joined
}

export const stringHasValue = (value: string | undefined | null): boolean => {
  return !isStringUndefinedOrBlank(value)
}

export const isStringUndefinedOrBlank = (value: string | undefined | null): boolean => {
  return (value?.trim().length ?? 0) === 0;
}

export const trimOrUndefined = (v?: string) => {
  const s = (v ?? '').trim();
  return s.length ? s : undefined;
};
